import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Content from "../../../Components/Dashboard/Content/Content";
import { getCompanyByIP } from "../../../Service/admin.service";

const CoinDCXGuide = () => {
  const [companyIP, setCompanyIP] = useState(null);

  useEffect(() => {
    fetchCompany();
  }, []);

  const fetchCompany = async () => {
    try {
      const res = await getCompanyByIP(); // your service function
      if (res?.status) {
        setCompanyIP(res?.data?.ip || "N/A");
      }
    } catch (error) {
      setCompanyIP("Error");
    }
  };

  return (
    <Content
      Page_title="Delta Exchange API Key Setup"
      button_title="Back"
      route="/client/apicreateinfo"
    >
      <div className="container py-4">

        {/* Step 1 */}
        <div className="card shadow-sm mb-4 border-0 rounded-3">
          <div className="card-body">
            <h5 className="fw-bold">Step 1: Login</h5>
            <p className="mb-0">
              Go to{" "}
              <a
                href="https://www.delta.exchange/"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://www.delta.exchange/
              </a>{" "}
              and log into your account.
            </p>
          </div>
        </div>

        {/* Step 2 */}
        <div className="card shadow-sm mb-4 border-0 rounded-3">
          <div className="card-body">
            <h5 className="fw-bold">Step 2: Open API Key Tab</h5>
            <p>
              Click on your profile icon (top right), and select{" "}
              <strong>API Key</strong> from the popup menu.
            </p>

            <div className="alert alert-info mb-0">
              <strong>
                Use this IP address:{" "}
                {companyIP ? companyIP : "Loading..."}
              </strong>
            </div>
          </div>
        </div>

        {/* Step 3 */}
        <div className="card shadow-sm mb-4 border-0 rounded-3">
          <div className="card-body">
            <h5 className="fw-bold">Step 3: View Screenshot</h5>
            <img
              src="https://res.cloudinary.com/dkqw7zkzl/image/upload/v1753070123/Screenshot_75_i9ybpy.png"
              alt="API Key Screenshot"
              className="img-fluid rounded border"
            />
          </div>
        </div>

        {/* Step 4 */}
        <div className="card shadow-sm mb-4 border-0 rounded-3">
          <div className="card-body">
            <h5 className="fw-bold">Step 4: Create API Key</h5>
            <p>
              Click the <strong>"Create API Key"</strong> button and follow the
              prompts.
            </p>
          </div>
        </div>

        {/* Step 5 */}
        <div className="card shadow-sm mb-4 border-0 rounded-3">
          <div className="card-body">
            <h5 className="fw-bold">Step 5: Save Keys</h5>
            <p>
              Copy your <strong>API Key</strong> and <strong>Secret Key</strong>{" "}
              and store them safely. You’ll need them for integration.
            </p>
          </div>
        </div>

        {/* Final Button */}
        <div className="text-center">
          <a
            href="https://www.delta.exchange/"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-primary px-4 py-2 fw-semibold"
          >
            Go to Delta Exchange
          </a>
        </div>

      </div>
    </Content>
  );
};

export default CoinDCXGuide;
